import { releaseNotes, upcoming } from "./releaseNotes";

export function ReleaseNotesPage() {
  return <div className="clients-page release-notes-page">
    <header className="release-notes-header"><h1>Release notes</h1><p>What changed in SignalBill.</p></header>
    {releaseNotes.map((entry) => <section className="release-notes-section" key={`${entry.date}-${entry.title}`} aria-label={entry.title}>
      <time dateTime={entry.date}>{new Intl.DateTimeFormat("en-US", { dateStyle: "long", timeZone: "UTC" }).format(new Date(`${entry.date}T00:00:00Z`))}</time>
      <h2>{entry.title}</h2>
      <ul>{entry.changes.map((change) => <li key={change}>{change}</li>)}</ul>
    </section>)}
    <section className="release-notes-section" aria-labelledby="release-notes-upcoming"><h2 id="release-notes-upcoming">Upcoming</h2><ul>{upcoming.map((item) => <li key={item}>{item}</li>)}</ul></section>
  </div>;
}
